/*
 * action types
 */

export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FIND_PROJECT = 'FIND_PROJECT';
export const ADD_PROJECT = 'ADD_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';

export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_ME = 'FETCH_ME';
export const ADD_USER = 'ADD_USER';
export const DELETE_USER = 'DELETE_USER';
export const EDIT_USER = 'EDIT_USER';

export const FETCH_ADDRESS_LIST = 'FETCH_ADDRESS_LIST';
export const DELETE_ADDRESS_LIST = 'DELETE_ADDRESS_LIST';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const FETCH_WINNERS = 'FETCH_WINNERS';
export const ADD_LOADING_COUNT = 'ADD_LOADING_COUNT';
export const DELETE_LOADING_COUNT = 'DELETE_LOADING_COUNT';

export const FETCH_FORM_LIST = 'FETCH_FORM_LIST';
export const ADD_FORM_LIST = 'ADD_FORM_LIST';
export const DELETE_FORM_LIST = 'DELETE_FORM_LIST';
export const FETCH_FORM = 'FETCH_FORM';
export const ADD_FORM_INPUT = 'ADD_FORM_INPUT';
export const EDIT_FORM_INPUT = 'EDIT_FORM_INPUT';
export const DELETE_FORM_INPUT = 'DELETE_FORM_INPUT';
export const EDIT_TERM = 'EDIT_TERM';
export const EDIT_COMPLETE = 'EDIT_COMPLETE';
export const EDIT_IMAGE = 'EDIT_IMAGE';
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const EDIT_START_AT = 'EDIT_START_AT';
export const EDIT_END_AT = 'EDIT_END_AT';

export const SHOW_ERROR = 'SHOW_ERROR';
export const CLOSE_ERROR = 'CLOSE_ERROR';

export const SHOW_POPUP = 'SHOW_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';

export const FETCH_FAQ = 'FETCH_FAQ';
export const GET_FAQ_CONTENT = 'GET_FAQ_CONTENT';

export const FETCH_CONTACT = 'FETCH_CONTACT';

export const FETCH_REGISTER_EMAIL = 'FETCH_REGISTER_EMAIL';
export const FETCH_REGISTER_COUNT = 'FETCH_REGISTER_COUNT';

export const FETCH_SERIAL_CODE_LIST = 'FETCH_SERIAL_CODE_LIST';
export const FETCH_SERIAL_CODE = 'FETCH_SERIAL_CODE';
export const FETCH_SERIAL_CODE_DATA = 'FETCH_SERIAL_CODE_DATA';
export const ADD_SERIAL_CODE = 'ADD_SERIAL_CODE';
export const DELETE_SERIAL_CODE = 'DELETE_SERIAL_CODE';
export const UPDATE_SERIAL_CODE = 'UPDATE_SERIAL_CODE';

export const FETCH_SURVEY_LIST = 'FETCH_SURVEY_LIST';
export const FETCH_SURVEY = 'FETCH_SURVEY';
export const ADD_SURVEY = 'ADD_SURVEY';
export const DELETE_SURVEY = 'DELETE_SURVEY';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';

export const FETCH_REFUND = 'FETCH_REFUND';
export const UPDATE_REFUND = 'UPDATE_REFUND';



// プロジェクト一覧の取得
export const fetchProjects = projects => {
    return { type: FETCH_PROJECTS, projects}
};
// プロジェクトの追加
export const addProject = project => {
    return { type: ADD_PROJECT, project}
};
// プロジェクトの編集
export const editProject = project => {
    return { type: EDIT_PROJECT, project}
};
export const findProject = project => {
    return {type: FIND_PROJECT, project}
};

// ユーザー一覧の取得
export const fetchUsers = operators => {
    return { type: FETCH_USERS, operators}
};
// ログインユーザーの取得
export const fetchMe = me => {
    return { type: FETCH_ME, me}
};
// ユーザーの追加
export const addUser = user => {
    return { type: ADD_USER, user}
};
// ユーザーの削除
export const deleteUser = user => {
    return { type: DELETE_USER, user}
};
// ユーザー権限の編集
export const editUser = user => {
    return { type: EDIT_USER, user}
};

// 配送先一覧
export const fetchAddressList = address => {
    return { type: FETCH_ADDRESS_LIST, address}
};
// 配送先一覧削除
export const deleteAddressList = () => {
    return { type: DELETE_ADDRESS_LIST}
};
// 配送先編集
export const editAddress = address => {
    return { type: EDIT_ADDRESS, address}
};
// 配送先削除
export const deleteAddress = address => {
    return { type: DELETE_ADDRESS, address}
};

// 当選者一覧
export const fetchWinners = winner => {
    return { type: FETCH_WINNERS, winner}
};

// ログイン関係
export const userLogin = user => {
    return { type: USER_LOGIN, user}
};
export const userLogout = user => {
    return { type: USER_LOGOUT, user}
};

// ローディング関係
export const addLoadingCount = () => {
    return { type: ADD_LOADING_COUNT};
};
export const deleteLoadingCount = () => {
    return { type: DELETE_LOADING_COUNT};
};

// フォームエディター関係
export const fetchFormList = forms => {
    return { type: FETCH_FORM_LIST, forms};
};
export const addForm = form => {
    return { type: ADD_FORM_LIST, form};
};
export const deleteForm = form => {
    return { type: DELETE_FORM_LIST, form};
};
export const fetchForm = form => {
    return { type: FETCH_FORM, form};
};
export const addFormInput = input => {
    return { type: ADD_FORM_INPUT, input};
};
export const editFormInput = input => {
    return { type: EDIT_FORM_INPUT, input};
};
export const deleteFormInput = input => {
    return { type: DELETE_FORM_INPUT, input};
};
export const editTerm = term => {
    return { type: EDIT_TERM, term};
};
export const editComplete = data => {
    return { type: EDIT_COMPLETE, data};
};
export const editImage = image => {
    return { type: EDIT_IMAGE, image};
};
export const deleteImage = image => {
    return { type: DELETE_IMAGE, image};
};
export const editStartAt = startAt => {
    return { type: EDIT_START_AT, startAt};
};
export const editEndAt = endAt => {
    return { type: EDIT_END_AT, endAt};
};

export const showError = error => {
    return { type: SHOW_ERROR, error};
};
export const closeError = () => {
    return { type: CLOSE_ERROR};
};

export const showPopup = popup => {
    return { type: SHOW_POPUP, popup};
};
export const closePopup = () => {
    return { type: CLOSE_POPUP};
};


// FAQ関係
export const fetchFaq = (faq, faqTypes) => {
    return { type: FETCH_FAQ, faq, faqTypes};
};
export const getFaqContent = (faqContents) => {
    return { type: GET_FAQ_CONTENT, faqContents};
};

// お問い合わせ関係
export const fetchContact = (contact, contactTypes) => {
    return { type: FETCH_CONTACT, contact, contactTypes};
};


// 事前登録関連
export const fetchRegisterEmail = register => {
    return { type: FETCH_REGISTER_EMAIL, register};
};
export const fetchRegisterCount = register => {
    return { type: FETCH_REGISTER_COUNT, register};
};


// シリアルコード
export const fetchSerialCodeList = serialCodes => {
    return { type: FETCH_SERIAL_CODE_LIST, serialCodes};
};
export const fetchSerialCode = serialCode => {
    return { type: FETCH_SERIAL_CODE, serialCode};
};
export const addSerialCode = serialCode => {
    return { type: ADD_SERIAL_CODE, serialCode};
};
export const updateSerialCode = serialCode => {
    return { type: UPDATE_SERIAL_CODE, serialCode};
};
export const deleteSerialCode = serialCode => {
    return { type: DELETE_SERIAL_CODE, serialCode};
};

//　シリアルコードデータ
export const fetchSerialCodeData = serialCodeData => {
    return { type: FETCH_SERIAL_CODE_DATA, serialCodeData};
};

// アンケート
export const fetchSurveyList = surveyList => {
    return {type: FETCH_SURVEY_LIST, surveyList};
};
export const fetchSurvey = survey => {
    return {type: FETCH_SURVEY, survey};
};
export const addSurvey = survey => {
    return {type: ADD_SURVEY, survey};
};
export const updateSurvey = survey => {
    return {type: UPDATE_SURVEY, survey};
};
export const deleteSurvey = survey => {
    return {type: DELETE_SURVEY, survey};
};

// 返金API
export const fetchRefund = refund => {
    return {type: FETCH_REFUND, refund};
};
export const updateRefund = refund => {
    return {type: UPDATE_REFUND, refund};
};
